import { gql, useLazyQuery } from '@apollo/client'

export const GET_COMPLIANCE_REPORT = gql`
  query GetComplianceReport {
    complianceReport {
      url
    }
  }
`

export const useComplianceReport = () =>
  useLazyQuery(GET_COMPLIANCE_REPORT, {
    fetchPolicy: 'network-only',
  })
